<div class="gigantes-bg-layout">
  <app-header mode="transparent"></app-header>
  <div class="main">
    <router-outlet></router-outlet>
  </div>
</div>
